import {Component, Input} from '@angular/core';
import {IdName} from '@domain/id-name';
import {ToolStatus} from '@domain/machine/tool-status.enum';
import {AssertionUtils, BaseComponent, EnumUtils} from '@vdw/angular-component-library';
import {takeUntil} from 'rxjs';
import {AddToolNavigationData} from '../add-tool-navigation-data.interface';
import {AddToolPageComponent} from '../add-tool-page.component';
import {ToolStatusForm} from '../tool.form';
import {StockLocationSelectionService} from './stock-location-selection.service';

@Component({
  selector: 'app-tool-status',
  templateUrl: './tool-status.component.html'
})
export class ToolStatusComponent extends BaseComponent {
  @Input() public form: ToolStatusForm;

  public toolStatuses = EnumUtils.getEnumValues(ToolStatus).filter((status: ToolStatus) => status !== ToolStatus.IN_USE);

  public constructor(
    private readonly addPage: AddToolPageComponent,
    private readonly stockLocationSelection: StockLocationSelectionService
  ) {
    super();
  }

  public get isStatusInUse(): boolean {
    return this.form.getRawValue().status === ToolStatus.IN_USE;
  }

  public selectStockLocation(): void {
    const field = this.form.controls.stockLocation;

    this.stockLocationSelection
      .openContentSwitcherDialog(field.value, {activeTab: this.addPage.selectedMenuItem, tool: this.addPage.getCurrentTool(), products: this.addPage.products} as AddToolNavigationData)
      .pipe(takeUntil(this.unSubscribeOnViewDestroy))
      .subscribe((location: IdName[]) => field.setValue(AssertionUtils.isEmpty(location) ? field.value : location[0]));
  }
}
